export default function AvatarIcon(props) {
  return (
    <svg
      viewBox="0 0 124 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1379_9666)">
        <circle cx="62" cy="62" r="62" fill="#9BCFF9" />
        <path
          d="M68.5 97.5L67.5 15L115.859 31.2661C121.039 40.325 124 50.8167 124 62C124 79.6833 116.597 95.6376 104.721 106.933L68.5 97.5Z"
          fill="#4AA2E9"
        />
        <path
          d="M88 50V40C88 25.6406 76.3594 14 62 14C47.6406 14 36 25.6406 36 40V50C36 60.037 41.6874 68.7457 50.0153 73.0791C49.7935 77.2927 48.9197 83.3284 46 88H62.0001H78C75.0803 83.3284 74.2065 77.2927 73.9847 73.0791C82.3126 68.7457 88 60.037 88 50Z"
          fill="#4040DC"
        />
        <path
          d="M48.9999 80L28.6003 87.2855C21.7284 89.7397 16.6497 95.3763 14.7822 102.183C26.1544 115.533 43.0882 124 61.9996 124C80.911 124 97.8448 115.533 109.217 102.183C107.35 95.3763 102.271 89.7397 95.3991 87.2855L74.9999 80C74.9999 80 72.4995 86.5 61.9999 86.5C51.5002 86.5 48.9999 80 48.9999 80Z"
          fill="#C9E8FA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1379_9666">
          <rect width="124" height="124" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}